<template>
	<inventory :initialcars="cars" :initialfeatureoptions="feature_options"></inventory>
</template>
<script>
import config from '@/config';
import Inventory from '@/components/Inventory';
import axios from 'axios';
export default {
	components: {
		inventory: Inventory
	},
	data() {
		return {
			cars: [],
			feature_options: [],
		}
	},
	async asyncData({ error, params, $axios, store  }){
		let formData = {
			action: "query",
			sort: "date_added",
			model: store.state.filters.model,
			sold: store.state.filters.sold,
			filter: store.state.filters.filter,
			vin: store.state.filters.vin,
			status: store.state.filters.status,
		};

		const encodeForm = (data) => {
			return Object.keys(data)
				.map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
				.join('&');
		}

		var queryString = encodeForm(formData);
		store.state.filters.features.map(function(value, key){
			queryString += "&features[]="+ encodeURIComponent(value.name);
		});

		const [carsRes, featuresRes] = await Promise.all([
    		$axios.post(config.API_URL+"?"+queryString, queryString),
    		$axios.post(config.API_URL+"?action=getFeatures")
		]);

		return {
			cars: carsRes.data.data || [],
			feature_options: featuresRes.data.data
		}
	}
}
</script>
<style lang="scss">
</style>
